<template>

  <el-table
    class="table-xs"
    style="width: 100%"
    width="100%"
    v-if="data"
    :data="data.Ekstre"
    show-summary
    :height="Height"
    :summary-method="TableFooter"
  >
    <el-table-column
      prop="tTarihi"
      label="T.Tarihi"
      width="100">
    </el-table-column>
    <el-table-column
      prop="sTarihi"
      label="S.Ö.Tarihi"
      width="100">
    </el-table-column>
    <el-table-column
      prop="Kategori"
      label="Kategori"
      width="100">
    </el-table-column>
    <el-table-column
      prop="Aciklama"
      label="Açıklama"
    >
    </el-table-column>
    <el-table-column
      prop="zBilgi"
      label="Zam Bilgi"
      width="100"
    >
    </el-table-column>
    <el-table-column
      prop="Tutar"
      label="Tutar"
      width="90"
      align="right">
    </el-table-column>
    <el-table-column
      prop="Zam"
      label="Zam"
      width="90"
      align="right">
    </el-table-column>
    <el-table-column
      prop="Toplam"
      label="Ödenecek"
      width="90"
      align="right">
    </el-table-column>
  </el-table>

</template>

<script>
export default {
  props:["data"],
  data() {
    return {
      Height: '73vh',
      tableData: []
    }
  },
  methods:{
    TableFooter() {
      const sums = [];
      sums[4] = this.data.AltToplam.Emanet;
      sums[5] = this.data.AltToplam.Tutar;
      sums[6] = this.data.AltToplam.Zam;
      sums[7] = this.data.AltToplam.Toplam;

      return sums;
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Raporlama/RaporlamaKisiBorcEkstre.vue